import App from "@/App.vue";

export default [
  {
    path: "/perfis",
    name: "profile",
    component: App,
    redirect: { name: "profile list" },
    children: [
      {
        path: "",
        name: "profile list",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ProfileList.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Perfis de Acesso",
              disabled: false,
              link: false,
              to: { name: "profile" }
            }
          ],
          displayName: "Lista Perfis - Lockton",
          requiresAuth: true
        }
      },
      {
        path: ":profileId",
        name: "profile details",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ProfileDetails.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Usuário",
              disabled: false,
              link: true,
              to: { name: "profile" }
            }
          ],
          displayName: "Detalhes do Perfil de Acesso - Lockton",
          requiresAuth: true
        }
      },
      {
        path: "novo-perfil",
        name: "profile new",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ProfileDetails.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Usuário",
              disabled: false,
              link: true,
              to: { name: "profile" }
            }
          ],
          displayName: "Novo Perfil de Acesso - Lockton",
          requiresAuth: true
        }
      }
    ]
  }
];
